import { Component, Input, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';
import { ApiResponseState } from '../../../store/api-response/api-response-state.model';
import { ApiResponseActions } from '../../../store/api-response/api-response-actions';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { vehicleProperties } from './properties/vehicle-properties';
import { headUnitProperties } from './properties/vehicle-properties';
import { dcmInfoProperties } from './properties/vehicle-properties';
import { convertToYearsAndMonths } from '../../../common/helpers/utils';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';
import { VehicleDispatcher } from '../../../store/vehicle-store/vehicle-dispatcher';
import { AdminDispatcher } from '../../../store/admin-store/admin-dispatcher';
import { SidenavService } from '../../services/sidenav.service';
import { SpinnerService } from '../../../common/components/spinner/overlay-spinner.service';
import { AdminApiHandlerService } from '../../services/api-handler/api-handler.service';
import { environment } from '../../../../environments/environment';
import { SnackBarService } from '../../../common/services/snack-bar/snack-bar.service';
import { FinegrainRolesService } from '../../../common/services/finegrain-roles/finegrain-roles.service';
import { Auth } from '../../../store/auth/auth-state.model';
import { NgIf, NgFor, NgTemplateOutlet } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatSuffix } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export interface Packages {
  paidPreview?: Array<object>;
  trialPreview?: Array<object>;
  paidSub?: Array<object>;
  trialSub?: Array<object>;
  goodWillSub?: Array<object>;
  preview?: object;
  subscriptions?: object;
}

@Component({
    selector: 'app-vehicle-summary',
    templateUrl: './vehicle-summary.component.html',
    styleUrls: ['./vehicle-summary.component.scss'],
    imports: [NgIf, NgFor, NgTemplateOutlet, MatIcon, MatSuffix, MatTooltip, MatButton, TranslatePipe]
})
export class VehicleSummaryComponent implements OnInit, OnDestroy {
  /**
  * @property Will contain vehicle details payload
  */
  @Input() vehicleDetails: object;
  /**
   * @property string that holds the vehicle description
   */
  public vehicle_description: string;
  /**
  *@property Used to set the brand name to the translations of the translate service
  *@type {object}
  **/
  public translateParams: object;
  /**
   *@property filtered capabilities
   **/
  public sortedCapabilities: any;
  /**
   * Property to observe the redux customer store
   **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
   * @property to store params
   */
  @Input()
  public params: object;
  /**
   * @property vehicleProperties
   */
  public vehicleProperties: Array<object> = vehicleProperties;
  /**
   * @property headUnitProperties
   */
  public headUnitProperties: Array<object> = headUnitProperties;
  /**
   * @property dcmInfoProperties
   */
  public dcmInfoProperties: Array<object> = dcmInfoProperties;

  /**
   * @property vehicleBrand propery to store the vehicle brand
   */
  public vehicleBrand: string;

  /**
   * @property dcmHeadUnitSection property is the concat of both head unit and dcm info
   */
  public dcmHeadUnitSection = [
    {
      'label': 'dcm-info',
      'properties': dcmInfoProperties
    },
    {
      'label': 'head-unit',
      'properties': headUnitProperties
    }
  ];

  /**
   * @property preferredDealerName propery to store the preferred dealer details
   */
  public preferredDealerInfo: string;
  /**
   * @property vin and guid of the preferred dealer request currently in flight
   */
  public preferredDealerRequestKey = '';
  /**
   * @property homeDealerInfo propery to store the Home dealer code
   */
  public homeDealerInfo: string;
  /**
   * @property Property to store the  subscription
   */
  public apiSubscription: Subscription;
  public translateSubscription: Subscription;
  /**
   * @property Property to store the remote extended capabilities subscription
   */
  public remoteList: string;
  /**
   * @property Property to store the unique capabilities
   */
  public uniqueCapabilities: any[];
  /**
   * @property Property to store the trial values of unique capabilities
   */
  public uniqueCapabilitiesTrialObject: any[];
  /**
   * @property Property to store the unique capabilities names
   */
  public uniqueCapabilitiesNames: any[];
  /**
   * @property Property to store the product packages
   */
  public productPackages: any;
  /**
   * @property Property to store the capabilities names
   */
  public capabilityNames: any[];
  /**
   * @property Property to store the value of 20TM
   */
  public is20TM = '';
  /**
   * @property used to store Array with Dest capabilities
   */
  public destCapabilities = ['Cloud Navigation', 'Intelligent Assistant', 'Destination Assist'];
  /**
   * @property Property to store the capability trial
   */
  public capabilityTrial: any;
  /**
   * @property Property to store the dest capability.
   */
  public destCapabilitiesList: string;
  /**
   * @property Property to store the trial length of remote connect.
   */
  public remoteTrialLength: any;
    /**
    * @property Property to store trial length subscriptions from API.
    */
    public trialLengths: any[] = [];
    /**
    * @property Property to identify trial lengths loading state.
    */
    public isTrialLengthsLoading = false;
  /**
     * @property Property to store Head Unit Manufacturer.
     */
  public HUCompanyData;
  /**
    *@arg authObservable observe auth variable in redux
    **/
  @select('auth') readonly authObservable: Observable<Auth>;

  constructor(
    public translate: TranslationService,
    public orch: OrchestrationService,
    public customerDispatcher: CustomerDispatcher,
    public apiDispatcher: ApiResponseDispatcher,
    public ngRedux: NgRedux<AppState>,
    public vehicleDispatcher: VehicleDispatcher,
    private adminDispatcher: AdminDispatcher,
    private sidenav: SidenavService,
    public spinner: SpinnerService,
    public apiHandler: AdminApiHandlerService,
    private snackBarService: SnackBarService,
    public finegrainRolesService: FinegrainRolesService,
  ) {
    this.apiSubscription = this.apiObservable.subscribe((api) => {
      const temp = api.apiAction === ApiResponseActions.SET_SUBSCRIBED_CUSTOMER && api.subscribedCustomer['type'] === 'success' && !!api.subscribedCustomer['customer'] ?
        this.findCustomerSuccess(api.subscribedCustomer['customer']) : api.subscribedCustomer['type'] === 'error' ? this.findCustomerError(api.subscribedCustomer) : null;
      if (ApiResponseActions.SET_HOME_DEALER && api.homeDealer['type'] === 'success' && !!api.homeDealer['homeDealerCode']) {
        this.homeDealerSuccess(api.homeDealer);
      }
      if (api.apiAction === ApiResponseActions.SET_PREFERRED_DEALER) {
        this.applyPreferredDealerResponse(api.preferredDealer);
      }
      if (api.apiAction === ApiResponseActions.SET_TRIAL_LENGTHS) {
        if (api.trialLengthsResponse['type'] === 'success' && api.trialLengthsResponse['payload']) {
          this.trialLengthsSuccess(api.trialLengthsResponse);
        } else if (api.trialLengthsResponse['type'] === 'error') {
          this.trialLengthsError(api.trialLengthsResponse);
        }
      }
      const productPackagesTemp = api.apiAction === ApiResponseActions.SET_PRODUCT_PACKAGES && api.productPackages['type'] === 'success' && !!api.productPackages['payload'] ?
        this.productPackagesSuccess(api.productPackages['payload']) : api.productPackages['type'] === 'error' ? this.productPackagesError(api.productPackages) : null;
    });
  }

  /**
  * findCustomerSuccess Action after a successful API response
  * @param response  Response of the API
  **/
  public findCustomerSuccess(customer: any): void {
    this.customerDispatcher.setCustomerData(customer);
    this.customerDispatcher.customerFound(true);
  }
  /**
  * errorCallback Action for error after API response
  * @param error  Response of the API
  **/
  public findCustomerError(error: object): void {
    this.apiDispatcher.setSubscribedCustomer({});
    this.snackBarService.showToast('Vehicle information failed to load.');
    if (error['customerFound'] === false) {
      this.customerDispatcher.customerNotFoundError(true);
    } else {
      this.orch.showError(error);
    }
  }

  /**
   * @function ngOnInit method to initializes the component and subscribe to the selected language
   */
  ngOnInit() {
    this.vehicle_description = this.vehicleDetails && this.vehicleDetails['modelDescription'] && this.vehicleDetails['modelDescription'].english ||
      this.vehicleDetails && this.vehicleDetails['model'] && this.vehicleDetails['model']['modelDescription'];
    this.vehicleBrand = this.getVehicleBrand(this.vehicleDetails);
    this.translateSubscription = this.translate.languageChange().subscribe((language: object) => {
      this.setTranslateParams();
    });
    this.setTranslateParams();
    this.vehicleDispatcher.setRemoteDetails({
      remoteUserGuid: this.vehicleDetails['remoteUserGuid'],
      remoteSubscriptionStatus: this.vehicleDetails['remoteSubscriptionStatus']
    });
    const remoteCapabilitiesList = this.ngRedux.getState().api.findVehicle['payload']['vehicle']['extendedCapabilities']['remoteCapabilities'];
    const evCapabilitiesList = this.ngRedux.getState().api.findVehicle['payload']['vehicle']['extendedCapabilities']['evCapabilities'];
    if (this.vehicleDetails) {
      if (!!remoteCapabilitiesList) { this.sortingCapabilities(remoteCapabilitiesList); }
      //this.getCapabilities(this.vehicleDetails['capabilities']);
      this.getHomeDealerDetails(this.vehicleDetails['vin'], this.vehicleDetails['subscriberGuid'], this.vehicleDetails['region'], this.vehicleDetails['brand']);
      this.getPreferredDealerDetails(this.vehicleDetails['vin'], this.vehicleDetails['subscriberGuid'], this.vehicleDetails['region'], this.vehicleDetails['brand']);
      this.getTrialLengths(this.vehicleDetails);
      this.getCapabilities(this.vehicleDetails['capabilities']);

      if (evCapabilitiesList) {
        evCapabilitiesList.forEach(capability => {
          if (capability.name === 'plugNCharge' && capability.value === true) {
            this.uniqueCapabilities.push({
              name: capability.name,
              value: capability.value,
              displayName: 'Plug and Charge'
            })
          }
        })
      }

      if (this.vehicleDetails['region'] === 'US') {
        this.orch.getHuCompany({

          modelCode: this.vehicleDetails['modelCode'],
          modelName: this.vehicleDetails['modelName'],
          mpc: this.vehicleDetails['headUnit'].mobilePlatformCode,
          mpcOption: 'true',
          year: this.vehicleDetails['modelYear'],
          headUnitConfigArray: [],

        }, (res) => {
          this.HUCompanyData = res.payload.headUnitsForCompaitibilityResponse.headUnits ? res.payload.headUnitsForCompaitibilityResponse.headUnits[0].headUnit : '';
        });
      }

    }
  }

  /**
   * @function getTrialLengths gets default trial lengths from API
   */
  public getTrialLengths(vehicleInfo: object): void {
    this.isTrialLengthsLoading = true;
    this.orch.getTrialLengths(vehicleInfo);
  }

  /**
   * @function trialLengthsSuccess handles successful trial lengths response
   */
  public trialLengthsSuccess(trialLengthsResponse: any): void {
    this.isTrialLengthsLoading = false;
    this.trialLengths = trialLengthsResponse['payload']?.['subscriptions'] ?? [];
    if (this.vehicleDetails && this.vehicleDetails['capabilities']) {
      this.getCapabilities(this.vehicleDetails['capabilities']);
    }
  }

  /**
   * @function trialLengthsError handles trial lengths API errors
   */
  public trialLengthsError(_trialLengthsError: object): void {
    this.isTrialLengthsLoading = false;
    this.trialLengths = [];
    this.snackBarService.showToast('Default trial lengths failed to load.');
    if (this.vehicleDetails && this.vehicleDetails['capabilities']) {
      this.getCapabilities(this.vehicleDetails['capabilities']);
    }
  }
  /**
   * @function ngOnDestroy Runs final sequence
   */
  ngOnDestroy() {
    this.apiSubscription.unsubscribe();
    this.translateSubscription.unsubscribe();
  }
  /**
    * @function settranslateParams sets the translation parms based on language change
    * @return void
    */
  public setTranslateParams(): void {
    this.translateParams = {
      'brand': this.vehicleDetails && this.vehicleDetails['brand'] === 'T' ? 'Toyota' : this.vehicleDetails && this.vehicleDetails['brand'] === 'S' ? 'Subaru' : 'Lexus',
      'brandSpecificName': this.translate.getCustomTranslation(this.vehicleDetails && this.vehicleDetails['brand'] === 'T' || this.vehicleDetails && this.vehicleDetails['brand'] === 'S' ? 'data-consent.label.customer' : 'data-consent.label.guest')['value'],
      'brandSpecificpackage': this.translate.getCustomTranslation(this.vehicleDetails && this.vehicleDetails['brand'] === 'T' || this.vehicleDetails && this.vehicleDetails['brand'] === 'S' ? 'sign-up.labels.ty.sign-up-form-title' : 'sign-up.labels.lx.sign-up-form-title')['value']
    };
  }
  /**
   * @function getCapabilities method to get the translation of the capability
   */
  public getCapabilities(vehicleCapabilities: Array<any>): void {
    this.is20TM = '';
    const dcm = !!this.vehicleDetails['dcm'].dcmModelYear ? this.vehicleDetails['dcm'].dcmModelYear === '19' : '';
    const headUnit = !!this.vehicleDetails['headUnit'].huVersion ? this.vehicleDetails['headUnit'].huVersion.split('-')[0] === '20TM' : '';
    const is17CYPLUS = this.vehicleDetails['generation'] === '17CYPLUS';
    if (!!dcm && !!headUnit && !!is17CYPLUS) {
      this.is20TM = '-20tm';
    }
    let hideCapabilities = ['RemoteAuthorizable', 'NavigationTrafficProbe', 'IpBasedTrafficAndWeather', 'RemoteCustom', 'AlternativeFuel'];
    vehicleCapabilities.forEach(element => {
      if (element.name !== 'Can300' && !element.displayName) {
        hideCapabilities.push(element.name);
      }
    });
    if (!!this.vehicleDetails['generation'] && this.vehicleDetails['generation'].toLowerCase() === '17cyplus') {
      hideCapabilities = [...hideCapabilities, 'appSuiteCapable'];
    }
    const seenDisplayNames = new Set<string>();
    this.uniqueCapabilities = vehicleCapabilities
      .filter(capability => (capability.name || capability.displayName) && hideCapabilities.indexOf(capability.name) < 0)
      .filter(capability => capability.name === 'Can300' || capability.value === true)
      .filter(capability => {
        const displayKey = capability.displayName || (capability.translation && capability.translation.english);
        if (!displayKey) {
          return capability.name === 'Can300';
        }
        if (seenDisplayNames.has(displayKey)) {
          return false;
        }
        seenDisplayNames.add(displayKey);
        return true;
      });
    this.sortDynamicNavigation();
    if (!(this.vehicleDetails['generation'] == '21MM' || this.vehicleDetails['generation'] == '24MM' || this.vehicleDetails['generation'] == '17CYPLUS') || this.is20TM) {
      this.sortedCapabilities = this.uniqueCapabilities.map(capability => {

        const capabilityDisplay = capability['name'] !== 'Can300' ? capability['translation'] && capability['translation']['english'] || capability['displayName'] : capability['name'];
        const capabilityName = capability['name'];
        const capabilityTrial = this.getCapabilityTrialFromApi(capabilityName, capabilityDisplay);
        const capabilityValue = capability['value'];
        return { capabilityDisplay, capabilityTrial, capabilityValue, capabilityName };
      });
    } else {
      this.getProductPackages(this.vehicleDetails);
    }
  }
  /**
 * @function sortDynamicNavigation function to sort dynamic navigation to show if any one of the capability is true among the dynamic navigation
 */
  public sortDynamicNavigation() {
    let filteredCapabilities, flag = true;
    filteredCapabilities = this.uniqueCapabilities.filter(word => word.displayName !== 'Dynamic Navigation');
    this.uniqueCapabilities.forEach(capability => {
      if (!flag) {
        return;
      }
      if (capability.displayName === 'Dynamic Navigation' && capability.value) {
        capability.name = 'DynamicMapRoute';
        filteredCapabilities = [...filteredCapabilities, capability];
        flag = false;
        this.uniqueCapabilities = filteredCapabilities;
      }
    });
  }
  /**
   * @function getPattern gets the translation pattern based on parameter - domain based, portal brand based
   */
  public getPattern(join1: string, join2: string, parameter: 'domain' | 'brand'): string {
    const joinParam = parameter === 'domain' ? '' : 'ty';
    return `${join1}${!!joinParam ? `-${joinParam}` : ''}${!!join2 ? `.${join2}` : ''}`;
  }

  /**
   * @function getSubproperty function to show nested properties
   */
  public getSubproperty(pathList, obj): string {
    if (pathList[0] === 'preferredDealer') {
      return this.preferredDealerInfo;
    } else if (pathList[0] === 'homeDealer') {
      return this.homeDealerInfo;
    } else if (pathList[0] === 'fleetInd') {
      const fleetIndicatorValue = obj['commercialRental'] && (obj.hasOwnProperty('activeDealerFleet') ? !obj['activeDealerFleet'] : true) ? 'Commercial Fleet' : obj['activeDealerFleet'] && (obj.hasOwnProperty('commercialRental') ? !obj['commercialRental'] : true) ? 'Dealer Fleet' : 'No';
      return fleetIndicatorValue;
    } else if (pathList[0] === 'electricalPlatformDescription') {
      return this.ngRedux.getState().api.findVehicle['payload'] && this.ngRedux.getState().api.findVehicle['payload']['vehicle']['electricalPlatformDescription'];
    } else {
      const propertyMap = pathList.map(path => {
        const properties = Array.isArray(path) ? path : path.split('.');
        const propertyReducer = properties.reduce((prev, curr) => prev && prev[curr], obj);
        return propertyReducer;
      });
      return propertyMap.filter(property => property)[0];
    }
  }

  /**
   * @function getVehicleBrand function to return vehicle brand
   */
  public getVehicleBrand(vehicle: object) {
    return vehicle && vehicle['brand'] && vehicle['brand'][0].toLowerCase() === 't' ||
      vehicle && vehicle['brandCode'] && vehicle['brandCode'][0].toLowerCase() === 't' ? 'TOYOTA' : vehicle && vehicle['brand'] && vehicle['brand'][0].toLowerCase() === 's' ||
        vehicle && vehicle['brandCode'] && vehicle['brandCode'][0].toLowerCase() === 's' ? 'SUBARU' : 'LEXUS';
  }

  /**
   * @function getHomeDealerDetails function to get the home dealer details
   */
  public getHomeDealerDetails(vin: string, guid: string, region: string, brand: string) {
    if (!!guid) {
      this.orch.getDealerDetails(vin, guid, region, brand, 'home-dealer');
    }
  }

  /**
   * @function getPreferredDealerDetails function to to get the preferred dealer details
   */
  public getPreferredDealerDetails(vin: string, guid: string, region: string, brand: string) {
    this.preferredDealerInfo = '';
    this.preferredDealerRequestKey = '';
    if (!!guid) {
      this.preferredDealerRequestKey = `${vin}|${guid}`;
      this.orch.getDealerDetails(vin, guid, region, brand, 'preferred-dealer');
    }
  }

  /**
   * Apply a preferred dealer response only when it belongs to the VIN and customer
   * currently shown. Responses left in the store from a previous dropdown selection are ignored.
   */
  public applyPreferredDealerResponse(preferredDealer: any): void {
    if (!this.isPreferredDealerForCurrentVehicle(preferredDealer)) {
      return;
    }
    if (preferredDealer['type'] === 'success') {
      this.preferredDealerSuccess(preferredDealer);
    } else {
      this.preferredDealerInfo = '';
    }
  }

  /**
   * @function isPreferredDealerForCurrentVehicle checks that the response was requested
   * for the vehicle now selected in the dropdown
   */
  public isPreferredDealerForCurrentVehicle(preferredDealer: any): boolean {
    if (!preferredDealer || !this.preferredDealerRequestKey || !this.vehicleDetails) {
      return false;
    }
    const responseKey = `${preferredDealer['requestVin']}|${preferredDealer['requestGuid']}`;
    return responseKey === this.preferredDealerRequestKey
      && preferredDealer['requestVin'] === this.vehicleDetails['vin']
      && preferredDealer['requestGuid'] === this.vehicleDetails['subscriberGuid'];
  }

  /**
  * homeDealerSuccess Action after a successful API response
  * @param response  Response of the API
  **/
  public homeDealerSuccess(homeDealerObject: any): void {
    const homeDealerCode = homeDealerObject['homeDealerCode'];
    const homeDealerName = homeDealerObject['homeDealerName'];
    this.homeDealerInfo = !!homeDealerName ? homeDealerName : '' + ' (' + homeDealerCode + ')';
  }

  /**
  * preferredDealerSuccess Action after a successful API response
  * @param response  Response of the API
  **/
  public preferredDealerSuccess(preferredDealerObject: any): void {
    const dealer = preferredDealerObject && preferredDealerObject[0];
    if (!dealer || !dealer['dealerCode']) {
      this.preferredDealerInfo = '';
      return;
    }
    const preferredDealerCode = dealer['dealerCode'];
    const preferredDealerName = dealer['dealerName'];
    this.preferredDealerInfo = preferredDealerName
      ? preferredDealerName + ' (' + preferredDealerCode + ')'
      : '(' + preferredDealerCode + ')';
  }
  /**
  * sortingCapabilities Action after a successful API response
  * @param extendedCapabilitiesObject  extended capabilities from vehicle details object
  **/
  public sortingCapabilities(extendedCapabilitiesObject: any): void {
    const extendedCapabilitiesTempObject = {};
    extendedCapabilitiesObject.forEach(element => {
      if (element.value === true) {
        extendedCapabilitiesTempObject[element.name] = element.value;
      }
    });
    const sortedCapabilities = extendedCapabilitiesTempObject;
    const remoteCapabilities = Object.keys(sortedCapabilities);
    const parsedList = remoteCapabilities.map(function (element) {
      element = element.replace(/([A-Z])/g, ' $1').trim();
      element = element.charAt(0).toUpperCase() + element.slice(1);
      return element;
    });
    this.remoteList = `Remote Capabilities\n\n` + parsedList.join('\n');
    this.destCapabilitiesList = this.destCapabilities.join('\n');

  }

  /**
  * getProductPackages method to call packages api to get 21MM specific trial products
  **/
  public getProductPackages(vehicleInfo: object): void {
    this.orch.getProductPackages(vehicleInfo);
  }

  /**
  * productPackagesSuccess Action after a successful API response of product package
  **/
  public productPackagesSuccess(productPackagesObject: any): void {
    this.uniqueCapabilitiesTrialObject = [];
    this.uniqueCapabilities.forEach(product => {
      if (product.name === 'Can300') {
        const temp = {
          capabilityDisplay: product.name,
          capabilityTrial: '',
          capabilityValue: product.value,
          capabilityName: product.name
        };
        this.uniqueCapabilitiesTrialObject.push(temp);
      } else if (product.displayName) {
        const temp = {
          capabilityDisplay: product.displayName,
          capabilityTrial: '',
          capabilityValue: product.value,
          capabilityName: product.name
        };
        this.uniqueCapabilitiesTrialObject.push(temp);
      }
    });
    const trialProducts = productPackagesObject['packages'].filter(product => {
      return product.packageType === 'Trial' && product.customerVisible;
    });
    this.uniqueCapabilitiesNames = [];
    this.uniqueCapabilitiesTrialObject.forEach(ele => {
      const temp = {
        displayName: ele.capabilityDisplay,
        name: ele.capabilityName
      };
      this.uniqueCapabilitiesNames.push(temp);
    });
    this.productPackages = this.productPackagesCapabilities(trialProducts);
    this.productPackages.forEach(element => {
      if (element.capabilityDisplay === 'Remote Connect with Digital Key' || element.capabilityDisplay === 'Remote Connect Lock/Unlock' || element.capabilityDisplay === 'Remote Connect Lock/Unlock with Digital Key'
        || element.capabilityDisplay === 'Remote Connect Vehicle Status' || element.capabilityDisplay === 'Enform Remote'
        || element.capabilityDisplay === 'EV Remote Connect' || element.capabilityDisplay === 'Remote Connect') {
        element.capabilityDisplay = 'Remote Connect';
      }
    });
    const combinedProductName = 'Navi + Voice Assist + DestAssist';
    this.capabilityNames = [];
    this.uniqueCapabilitiesNames.forEach((element, index) => {
      const capabilityName = element['name'];
      this.capabilityTrial = this.getCapabilityTrialFromApi(capabilityName, element['displayName']);
      this.uniqueCapabilitiesTrialObject[index]['capabilityTrial'] = this.capabilityTrial;
      if (!!element['displayName'] && !element['name'].includes('RemoteCapable', 'EvRemoteService')) {
        this.capabilityNames.push(element['displayName']);
      }
      if (!!element['displayName'] && element['name'].includes('RemoteCapable', 'EvRemoteService')) {
        this.capabilityNames.push('Remote Connect');
      }
      if (!!element['displayName'] && element['name'].includes('plugNCharge', 'plugNCharge')) {
        this.capabilityNames.push('Plug and Charge');
      }
      if (!!element['capabilityDisplay'] && element['capabilityName'].includes('RemoteCapable', 'EvRemoteService')) {
        this.uniqueCapabilitiesNames[index]['capabilityDisplay'] = 'Remote Connect';
      }
    });
    this.uniqueCapabilitiesTrialObject.forEach((element, index) => {
      if (!!element['capabilityDisplay'] && element['capabilityName'].includes('RemoteCapable', 'EvRemoteService')) {
        this.uniqueCapabilitiesTrialObject[index]['capabilityDisplay'] = 'Remote Connect';
      }
    });
    this.productPackages.forEach(product => {
      if (product.capabilityDisplay === combinedProductName) {
        this.uniqueCapabilitiesTrialObject.forEach((ele, index) => {
          if (ele.capabilityDisplay === 'Drive Connect') {
            this.uniqueCapabilitiesTrialObject[index]['capabilityTrial'] = product['capabilityTrial'];
          } else {
            if (ele.capabilityDisplay === 'Mm21Navigation') {
              this.uniqueCapabilitiesTrialObject[index]['capabilityTrial'] = product['capabilityTrial'];
            } else if (ele.capabilityDisplay === 'Virtual Assistant') {
              this.uniqueCapabilitiesTrialObject[index]['capabilityTrial'] = product['capabilityTrial'];
            } else if (ele.capabilityDisplay === 'Destination Assist') {
              this.uniqueCapabilitiesTrialObject[index]['capabilityTrial'] = product['capabilityTrial'];
            } else if (ele.capabilityDisplay === 'Wi-Fi Connect') {
              this.uniqueCapabilitiesTrialObject[index]['capabilityTrial'] = '1 Month / 3 GB';
            }
          }
        });
      } else if (this.capabilityNames.includes(product.capabilityDisplay)) {
        const index = this.uniqueCapabilitiesTrialObject.findIndex(ele => ele.capabilityDisplay === product.capabilityDisplay);
        this.uniqueCapabilitiesTrialObject[index]['capabilityTrial'] = product['capabilityTrial'];
      }
    });
    this.productPackages.forEach(ele => {
      if (ele['capabilityDisplay'] === 'Remote Connect') {
        this.remoteTrialLength = ele['capabilityTrial'];
      }
    });
    this.uniqueCapabilitiesTrialObject.forEach(ele => {
      if (ele['capabilityDisplay'] === 'RemoteCapable' || ele['capabilityDisplay'] === 'EvRemoteService' || ele['capabilityDisplay'] === 'Remote Connect (features may vary)'
        || ele['capabilityDisplay'] === 'Remote Connect') {
        ele['capabilityTrial'] = this.remoteTrialLength;
      }
    });
    this.sortedCapabilities = this.uniqueCapabilitiesTrialObject;
  }

  /**
  * productPackagesError Action after an error from API response
  **/
  public productPackagesError(productPackagesError: object): void {
    this.apiDispatcher.setPackageProducts({});
    this.snackBarService.showToast('Vehicle Packages failed to load.');
  }

  /**
  * productPackagesCapabilities method will return the capability object of package products
  **/
  public productPackagesCapabilities(trialProducts): object {
    this.productPackages = [];
    trialProducts.forEach(product => {
      const temp = {
        capabilityDisplay: product['product'].productName,
        capabilityTrial: convertToYearsAndMonths(product['product'].term),
        capabilityValue: true
      };
      this.productPackages.push(temp);
    });
    return this.productPackages;
  }

  /**
  * getCapabilityTrialFromApi resolves trial length from subscriptions API payload
  **/
  private getCapabilityTrialFromApi(capabilityName: string, capabilityDisplay?: string): string {
    if (!this.trialLengths?.length) {
      return '';
    }

    const trialNameCandidates = this.getTrialLengthCandidates(capabilityName, capabilityDisplay);
    const trialLength = this.trialLengths.find((subscription) => {
      const productName = this.normalizeTrialName(subscription?.['productName']);
      return trialNameCandidates.some((candidate) => this.normalizeTrialName(candidate) === productName);
    });

    return trialLength?.['termDisplay'] ?? '';
  }

  /**
  * getTrialLengthCandidates builds candidate labels to map capability names to trial API product names
  **/
  private getTrialLengthCandidates(capabilityName: string, capabilityDisplay?: string): string[] {
    const generation = this.vehicleDetails?.['generation']?.toLowerCase() || '';
    const isLegacyGen = generation === '17cy';
    const isPlusGen = generation === '17cyplus';
    let destCapableDisplay = 'Drive Connect';
    if (isLegacyGen) {
      destCapableDisplay = 'DestCapable';
    } else if (isPlusGen) {
      destCapableDisplay = 'Destination Assist';
    }

    const capabilityMap = {
      RemoteCapable: 'Remote Connect',
      EvRemoteService: 'Remote Connect',
      DestCapable: destCapableDisplay,
      SafetyConnect: isLegacyGen ? 'SafetyConnect' : 'Safety Connect',
      ServiceConnectFull: 'Service Connect',
      DynamicMapRoute: 'Drive Connect',
      WiFiConnect: 'Wi-Fi Connect'
    };

    return [
      capabilityMap[capabilityName],
      capabilityDisplay,
      capabilityName
    ].filter(Boolean);
  }

  /**
  * normalizeTrialName normalizes product and capability names for lenient matching
  **/
  private normalizeTrialName(value: string): string {
    return (value || '')
      .toLowerCase()
      .split('')
      .filter((character) => /[a-z0-9]/.test(character))
      .join('');
  }
  /**
  * isRemoteCapable method will return true if it is remote capable
  **/
  public isRemoteCapable(capability: string): boolean {
    if (capability === 'RemoteCapable' || capability === 'EvRemoteService' || capability === 'Remote Connect (features may vary)') {
      return true;
    } else {
      return false;
    }
  }

  /**
* isDestCapable method will return true if it is  Dest capable.
**/
  public isDestCapable(capability: string): boolean {
    return capability === 'DestCapable' ? true : false;

  }

  /**
   * @function toggleSidenavComponent toggles the side nav to open the app features
   **/
  public toggleSidenavComponent(componentName: string): void {
    this.adminDispatcher.setUpdateInfo(componentName, '', '', '');
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }


  /**
  * getTranslatedString method will return the translated string
  **/
  public getTranslatedString(input: string): string {
    return 'vehicleSummary.capabilities.' + input;
  }
  /**
   * @function getPermission get Permissions to display features inside customer card
   */
  public getPermission(feature: string): boolean {
    return this.finegrainRolesService.getCustomerPermissions(feature);
  }

  /**
  *  Triggers the remote list side menu
  **/
  public showRemoteListMenu(): void {
    const vehicleDetails = this.ngRedux.getState().api.findVehicle['payload']['vehicle'];
    const remoteEngineStartStopExists = vehicleDetails['extendedCapabilities']['remoteCapabilities'].findIndex(ele => ele.name === 'remoteEngineStartStop')
    if ((vehicleDetails['fuelType'] === 'E' || vehicleDetails['fuelType'] === 'I') && remoteEngineStartStopExists > -1) {
      vehicleDetails['extendedCapabilities']['remoteCapabilities'].splice(remoteEngineStartStopExists, 1);
    }
    const extendedCapabilities = vehicleDetails['extendedCapabilities'];
    this.adminDispatcher.setUpdateInfo('vehicle-remotelist', 'vehicle-remotelist', 'vehicle-remotelist', '', extendedCapabilities);
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }
  /**
    * reSyncSettableFlags method will re sync all the settable flags
    **/
  public reSyncSettableFlags(): void {
    const spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(environment.admin.apis.subscription.reSyncFlags, {
      type: 're-sync-settable-flags', params: {
        'vin': this.vehicleDetails['vin'],
        'reSyncSettableFlags': true
      }
    }).subscribe({
      next: (response) => {
        this.snackBarService.showToast('Re-sync settable flags has been completed successfully!');
        spinnerRef.close();
      },
      error: (error) => {
        this.snackBarService.showToast('An error occured!');
        spinnerRef.close();
      }
    });
  }

  /**
   * @function isDCMProp used to identify imei property
   */
  public isDCMProp(prop): boolean {
    if (prop.label === 'imei') {
      return true;
    }
    return false;
  }
}
